<template>
  <div class="d-md-flex align-items-center ts-justify-between mb-4">
    <div class="pos-booking-title flex-1">
      <div class="ts-text-2xl ts-text-gray-800 mb-1">Table list</div>
      <!-- <div class="mb-2 mb-md-0 d-flex">
        <div class="d-flex align-items-center mr-3">
          <i class="fa fa-circle fa-fw text-gray-700 f-s-9 mr-1"></i> Completed
        </div>
        <div class="d-flex align-items-center mr-3">
          <i class="fa fa-circle fa-fw text-warning f-s-9 mr-1"></i> Upcoming
        </div>
        <div class="d-flex align-items-center mr-3">
          <i class="fa fa-circle fa-fw text-success f-s-9 mr-1"></i> In-progress
        </div>
      </div> -->
    </div>
    <div>
      <a-date-picker 
        v-model="dateBooking"
        :allowClear="false"
        format="DD-MM-YYYY"
        valueFormat="DD-MM-YYYY"
        @change="fetchData" 
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  computed: {
    dateBooking: {
      get() {
        return this.$store.state.booking.tableBooking.bookingDate
      },
      set(newValue) {
        this.$store.commit('booking/tableBooking/SET_BOOKING_DATE', newValue)
      }
    }
  },
  methods: {
    ...mapActions('booking/tableBooking', ['fetch']),
    fetchData(){
      this.$emit('loading', true)
      this.fetch()
      .finally(() => {
        this.$emit('loading', false)
      })
    }
  }
}
</script>